import { render } from "./OwnerMenu.vue?vue&type=template&id=37d27240"
import script from "./OwnerMenu.vue?vue&type=script&lang=js"
export * from "./OwnerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__